import {useEffect, useMemo, useRef} from 'react'

import {usePaginatedMemexItemsQuery} from '../../state-providers/memex-items/queries/use-paginated-memex-items-query'
import useIsVisible from '../board/hooks/use-is-visible'

export const useVisiblePagination = ({groupId}: {groupId?: string}) => {
  const ref = useRef<HTMLDivElement | null>(null)
  const {isVisible} = useIsVisible({ref})
  const prevIsVisible = useRef<boolean>(false)
  const {
    isFetchingNextPage,
    isFetchingNextPageForGroup,
    fetchNextPage,
    fetchNextPageForGroup,
    hasNextPage,
    hasNextPageForGroup,
  } = usePaginatedMemexItemsQuery()
  useEffect(() => {
    // isVisible remains briefly true after fetchNextPage completes.
    // This check prevents an extra request from being fired.
    if (prevIsVisible.current === isVisible) return
    prevIsVisible.current = isVisible
    if (!isVisible) return
    if (groupId && hasNextPageForGroup(groupId) && !isFetchingNextPageForGroup(groupId)) {
      fetchNextPageForGroup(groupId)
    } else if (hasNextPage && !isFetchingNextPage) {
      fetchNextPage()
    }
  }, [
    isVisible,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage,
    groupId,
    fetchNextPageForGroup,
    hasNextPageForGroup,
    isFetchingNextPageForGroup,
  ])

  return useMemo(
    () => ({
      ref,
      hasNextPage: groupId ? hasNextPageForGroup(groupId) : hasNextPage,
    }),
    [groupId, hasNextPage, hasNextPageForGroup],
  )
}
